<div class="avatar">
  <span>{{ initials }}</span>
</div>
